import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { DeleteComponent } from '../../../components/general/general-component/abstruct-component/DeleteComponent'
import { VariableWarehouse } from './VariableWarehouse'
import Table2 from '../../../components/table/Table2'
import InnerLoader from '../../../components/general/inner-loader/InnerLoader'
import Warning from '../../../components/general/general-component/warning-delete/Warning'
import { ColumnWarehouses } from '../../../components/general/general-component/columns-component/ColumnWarehouses'
import { deleteWarehouse, loadWarehouses } from '../../../store/Actions/ActionWarehouses'
import AddWarehouse from './AddWarehouse'
import EditWarehouse from './EditWarehouse'
import FilterWarehouse from './FilterWarehouse'
import ZonesShow from './zones/ZonesShow'
import Tabs from '../../../components/general/general-component/tabs/Tabs'
import { UsePermissions, hasPermissions } from '../../../components/general/general-component/abstruct-component/UsePermissions'
import NoPermissions from '../../no-permissions'
import LoaderPermissions from '../../no-permissions/LoaderPermissions'
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader'


const ShowWarehouses = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const warehousesPer = hasPermissions([{ name: "warehouses" }], permissionss);
    const warehouse_zones_per = hasPermissions([{ name: "warehouse-zones" }], permissionss);
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { warehouses, loadingWarehouses } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit } = VariableWarehouse()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [warehousesArr, setWarehousesArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    const [activeTap, setActiveTap] = useState('warehouses')
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...warehousesArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setWarehousesArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, warehousesArr]);
    useEffect(() => {
        if (warehouses?.length >= 0) {
            setWarehousesArr(warehouses)
        }
    }, [warehouses]);
    useEffect(() => {
        dispatch(loadWarehouses())
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteWarehouse(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openWarehouse = e => {
        e.preventDefault()
        setOpen(true)
    }
    const editStatus = (id, status) => {
        let newStatus;
        if (status === 1) {
            newStatus = 0
        } else {
            newStatus = 1
        }
        /*dispatch(blockUser(id, newStatus, setloadDel));*/
    }
    const detailsOfWarehouse = (id) => {
        navigate(`/warehouses/${id}`)
    }
    const productsByWarehouse = (id, name) => {
        navigate(`/warehouse/${id}/${name}/products`)
    }
    const handleSectionClick = (sectionId) => {
        setActiveTap(sectionId);
    };
    const tabs = [
        {
            name: translate('warehouses'),
            type: 'warehouses',
            icon: 'fa-solid fa-warehouse'
        },
        {
            name: translate('zones'),
            type: 'zones',
            icon: 'fa-solid fa-vector-square'
        }
    ]
    const { columns } = ColumnWarehouses(translate, warning, handleEdit, editStatus, langLocal, detailsOfWarehouse, productsByWarehouse)
    return (
        <CheckLazyLoader>
            <main>
                {/*<FilterUser translate={translate} />*/}

                <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ position: "relative" }} >
                    {/*<div className='product_page' >*/}
                    {/*<SidebarWarehouse activeTap={activeTap} setActiveTap={setActiveTap} />*/}
                    <Tabs langLocal={langLocal} tabs={tabs} activeSection={activeTap} handleSectionClick={handleSectionClick} />

                    {
                        activeTap === 'warehouses' && (
                            <>
                                {
                                    warehousesPer && !loadingMainPermission &&
                                    <div>
                                        <FilterWarehouse translate={translate} bigTitle titleBtn={translate('add-warehouse')} FunctionBtn={openWarehouse} />
                                        {
                                            loadingWarehouses ? (
                                                <InnerLoader />
                                            ) : <Table2 col={columns} roo={warehousesArr} />
                                        }
                                    </div>
                                }
                                {
                                    !warehousesPer && !loadingMainPermission && (
                                        <NoPermissions isHeight />
                                    )
                                }
                                {
                                    loadingMainPermission && (
                                        <LoaderPermissions isHeight />
                                    )
                                }
                            </>
                        )
                    }
                    {
                        activeTap === 'zones' && (
                            <>
                                {
                                    warehouse_zones_per && !loadingMainPermission &&
                                    <div >
                                        <ZonesShow />
                                    </div>
                                }
                                {
                                    !warehouse_zones_per && !loadingMainPermission && (
                                        <NoPermissions isHeight />
                                    )
                                }
                                {
                                    loadingMainPermission && (
                                        <LoaderPermissions isHeight />
                                    )
                                }

                            </>
                        )
                    }
                    {/*</div>*/}
                </div>
            </main>
            {
                state.open && (
                    <AddWarehouse open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditWarehouse arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </CheckLazyLoader>
    )
}

export default ShowWarehouses
